// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cashflow-label .colored-box[data-v-21970b13] {\n  width: 10px;\n  height: 10px;\n  border: none;\n  border-radius: 4px;\n  background-color: red;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
